import firebase from "firebase/app";
import "firebase/storage";
import "firebase/firestore";
import "firebase/auth";

export const app = firebase.initializeApp({
  apiKey: "AIzaSyAgflmJdWDqF0Ij1OzbUjN-H7ofzwENKvg",
  authDomain: "myth-maker.firebaseapp.com",
  projectId: "myth-maker",
  storageBucket: "myth-maker.appspot.com",
  messagingSenderId: "514658010179",
  appId: "1:514658010179:web:0b190203840c771cb580f6",
});
